
export default "/assets/no-symbol-micro.d3116b4b.svg"